import { Component } from 'preact';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

// Utils
import {
  calcColumns,
  isLoadingOnField,
  stepShowHide,
  stepToggleType,
} from '../../../utilities/form/formUtils';
import { getButtonVisible } from '../../../utilities/section/sectionUtils';

// Constants
import { stepComponents } from '../../../constants/Steps';

// Components
import StepHeader from '../General/StepHeader';
import { getStepTitle, triggerView } from '../../../utilities/adobeTarget';

// Action
import { userDataService } from '../../../utilities/api/userData';
import { nextStepAction, prevStepAction } from '../../../actions/Section';
import NavigationContainer from '../../Global/NavigationContainer';

class Login extends Component {
  constructor() {
    super();
    const referer = window.location.href;
    const params = {
      referer,
    };
    const encodeState = btoa(JSON.stringify(params));
    this.state = {
      encodeResponseData: encodeState,
    }
  }

  componentDidMount() {
    const { dispatch, userData, actions } = this.props;
    if (userData.loginStatus === 'undefined' || !userData.loginStatus) {
      const viewName = getStepTitle();
      if (viewName) {
        triggerView(viewName);
      }
      dispatch(userDataService.saveUserData());
    } else {
      const stepAction = sessionStorage.getItem('action');
      if (stepAction === null || stepAction === 'next') {
        actions.nextStepAction();
      } else if (stepAction === 'prev') {
        actions.prevStepAction();
      }
    }
  }

  render() {
    const {
      componentProps,
      title,
      desc,
      dispatch,
      errors,
      handleSubmit,
      onBlur,
      onChange,
      setValues,
      touched,
      values,
      setFormValues,
      userData,
      initialValues,
      setFieldValue,
      className,
      hidden,
      showHide,
      currentProgress,
      btn,
      hideNext,
      isValid,
      submitLabel,
      nextButtonLinkUrl,
      submitIcon,
      actionsButtons,
      translations,
      nextButtonDivClassName,
      submitClass,
      tracking,
    } = this.props;

    const { encodeResponseData } = this.state;

    const formParams = {
      handleSubmit,
      onChange,
      onBlur,
      errors,
      touched,
      setValues,
      values,
      setFormValues,
      dispatch,
      userData,
      setFieldValue,
      initialValues,
    };

    let navigationBtn = btn;

    if (stepShowHide(hidden, showHide, userData, values)) {
      return <div/>;
    }

    return (
      <article className={`step step--basic ${className}`}>
        {(title || desc) && (
          <StepHeader title={title} desc={desc}/>
          )}

        {/* If there's any props */}
        {componentProps.length > 0 && (
          <div className="step__content">
            {componentProps.map(componentProp => {
                  if (componentProp.id === 'loginError' &&
                  (userData.loginStatus === true || userData.loginStatus === undefined) &&
                  (userData.loginErrorCode === undefined || userData.loginErrorCode === null)) {
                    return null;
                  }
                  const { loadingOnField } = componentProp;
                  const hiddenLocal = componentProp.hidden || false;
                  const showHideLocal = componentProp.showHide || null;
                  const toggleType = componentProp.toggleType || null;
                  let inputParams = {
                    ...componentProp,
                    ...formParams,
                    isLoading: loadingOnField ? isLoadingOnField(loadingOnField, userData) : null,
                    'columns': calcColumns(componentProp),
                    'children': componentProps,
                    hidden: (stepShowHide(hiddenLocal, showHideLocal, userData, values)),
                    toggleType: (stepToggleType(toggleType, userData, values)),
                  };
                  const InputComponent = stepComponents[componentProp.type];

                  if (componentProp.iconPos && encodeResponseData !== '') {
                    inputParams = {
                      ...inputParams,
                      encodeResponseData,
                    };
                  }
                  return (
                    <>
                      {
                        encodeResponseData !== '' && !inputParams?.navigationContainer ? <InputComponent {...inputParams}/> : <noScript/>
                      }
                      {
                        encodeResponseData !== '' && inputParams?.navigationContainer === true ? 
                        <NavigationContainer 
                          dispatch={dispatch}
                          currentProgress={currentProgress}
                          config={currentProgress.backButtonConfig}
                          displayImage={currentProgress.displayImgSection}
                          nextButtonStyle={ { display: getButtonVisible(hideNext, isValid) } }
                          nextButtonClassName={submitClass}
                          nextButtonOnClick={e => actionHandler(formActions, null, e, dispatch,
                            { ...values, setFieldValue })}
                          nextButtonRef={node => (navigationBtn = node)}
                          nextButtonDisabled={!isValid}
                          nextButtonDataTealium={`{"link_text": "${submitLabel}"}`}
                          nextButtonLabel={submitLabel}
                          nextButtonLinkUrl={nextButtonLinkUrl}
                          nextButtonSubmitIcon={submitIcon}
                          nextButtonType={"link"}
                          nextButtonActionsButtons={actionsButtons}
                          nextButtonLinkTracking={tracking}
                          nextButtonLinkTranslations={translations}
                          nextButtonLinkEncodeResponseData={encodeResponseData}
                          nextButtonDivClassName={nextButtonDivClassName}
                          nextButtonInputParams={inputParams}
                        /> : <></>
                      }
                    </>
                  );
                })}
          </div>
        )}
      </article>
    );
  }
}

export default compose(
  connect((state) => {
    const { app, userData } = state;
    return {
      app,
      userData,
    };
  }, (dispatch) => ({
    actions: bindActionCreators({
      nextStepAction,
      prevStepAction,
    }, dispatch),
  }))
)(Login);

Login.defaultProps = {
  desc: null,
  errors: null,
  title: null,
  className: '',
  hidden: false,
  showHide: null,
};

Login.propTypes = {
  componentProps: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  submitText: PropTypes.string.isRequired,
  desc: PropTypes.string,
  errors: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  setFormValues: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  title: PropTypes.string,
  touched: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  className: PropTypes.string,
  hidden: PropTypes.bool,
  showHide: PropTypes.object,
  activeSectionData: PropTypes.object.isRequired,
  currentProgress: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  btn: PropTypes.object,
  hideNext: PropTypes.bool,
  isValid: PropTypes.bool,
  submitLabel: PropTypes.string,
  nextButtonLinkUrl: PropTypes.string,
  submitIcon: PropTypes.bool,
  actionsButtons: PropTypes.array,
  translations: PropTypes.object,
  nextButtonDivClassName: PropTypes.string,
  submitClass: PropTypes.string,
  tracking: PropTypes.array,
};
